export default __webpack_public_path__ + "static/media/sunbed.b7e347eb.png";